import { orchestrator } from 'satcheljs';
import { preloadApps, appsPreloaded } from '../actions/internalActions';
import { getStore } from '../store/store';
import { addPrefetchIFrameToDocument } from '../utils/addPrefetchIFrameToDocument';
import { getPreloadURLForWXP } from '../utils/getPreloadURLForWXP';
import { getWacPreloadMappings } from '../utils/getWacPreloadMappings';
import type { OfficeOnlineApp } from 'owa-file';

orchestrator(preloadApps, ({ appsToPreload }) => {
    const store = getStore();
    // Remove any apps that have already been preloaded
    appsToPreload = appsToPreload.filter(app => !store.appsPreloaded[app]);

    appsPreloaded(appsToPreload);

    getPreloadURLForApps(appsToPreload)
        .filter(url => !!url)
        .forEach(addPrefetchIFrameToDocument);
});

function getPreloadURLForApps(apps: OfficeOnlineApp[]) {
    const wacPreloadMappings = getWacPreloadMappings();
    const preloadUrlsForApps = getPreloadURLForWXP(wacPreloadMappings);

    return apps.map(app => preloadUrlsForApps[app]);
}
